import "./CursadasList.css";
import { getCoursesByUser } from '../../../Services/Courses.js';
import { useEffect, useState } from "react";
import "../MainFrame.css"
import DialogModal from "../../Modals/dialogModal";


const Cursadaslist = (props) => {

    const [listData, setListData] = useState([]);
    const [showModal, setShowModal] = useState(false)

    
    const loadData = async () => {
        let rsp = await getCoursesByUser();

        if(rsp?.Error == false){
            setListData(rsp.Data);
        }else{
            setShowModal(true)
        }   
    }

    const goToCourse = (id) => {
        props.setActualCourseId(id);
        props.setActualFrame('cursada');
    }

    useEffect(() => {
        loadData();
    }, []);

    return(
        <div className="frame">
            <DialogModal showModal={showModal} setShowModal={setShowModal}>
                <h3>En este momento no se pudo acceder al recurso.</h3>
            </DialogModal>
            <div className="cursadasListContainer">
                <div className="cursadasListLayout">
                    <div className="cursadasListTitle">
                        <h3 className="cursadasListElement">Nombre de la cursada</h3>
                        <h3 className="cursadasListElement">Acciones</h3>
                    </div>
                    {
                        listData.map((item, index) => {
                            return(
                            <div div className="cursadasListContent" key={index}>
                                <h3 className="cursadasListElement">{item.title}</h3>
                                <button className="green-btn cursadasListElement" onClick={() => goToCourse(item.id)}>Ingresar</button>
                            </div>
                            );
                        })
                    }
                    <div className="cursadas-list-footer"></div>
                    </div>
                </div>
        </div>
    );
}

export default Cursadaslist;